export enum CreditTypes {
  StateTax = 'StateTax',
  FederalTax = 'FederalTax',
}

export enum CompanyType {
  LLC = 'llc',
  CCorp = 'ccorp',
}

export enum CompanyStructure {
  SingleMemberLLC = 'Single-Member-LLC',
  MultiMemberLLC = 'Multi-Member-LLC',
  CCorp = 'C-Corp',
}

export enum OwnerType {
  Individual = 'individual',
  Company = 'company',
}

export enum OnboardingStatus {
  InProgress = 'in_progress', // Initial state
  Processing = 'processing', // When creating entities for user (clicked complete onboarding button)
  Completed = 'completed', // When all entities are created and payment is done if new company
}

export enum CompanySource {
  FormedByUs = 'formed_by_us', // Company formed through our platform
  ExistingCompany = 'existing_company', // Existing company joining the platform
}

export enum AddressType {
  Primary = 'primary', // Primary / registered address (required for all)
  Mailing = 'mailing', // Mailing address (required for WY, optional for others)
}

export enum PricingPackageType {
  Standard = 'standard',
  Full = 'full',
}

export enum TaxIdType {
  SSN = 'SSN',
  EIN = 'EIN',
  ITIN = 'ITIN',
  FTIN = 'FTIN',
}

export enum CompanyDocumentCategory {
  EIN = 'ein',
  Operation = 'operation',
  Formation = 'formation',
  S83b = 's83b',
  Tax = 'tax',
  Others = 'others',
}

export enum StateSupportedByUs {
  DE = 'DE',
  WY = 'WY',
}
